import React from 'react';

const Pagination = ({ usersPerPage, totalUsers, paginate, currentPage }) => {
    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(totalUsers / usersPerPage); i++) {
        pageNumbers.push(i);
    }

    return (
        <nav className='container mx-auto p-6'>
            <ul className="flex justify-center mt-4">
                {pageNumbers.map(number => (
                    <li key={number} className={`mx-1 ${currentPage === number ? 'font-bold' : ''}`}>
                        <button
                            onClick={() => paginate(number)}
                            className={`px-3 py-1 ${currentPage === number ? 'font-bold bg-green-300' : 'bg-gray-200'} rounded hover:bg-gray-300`}
                        >
                            {number}
                        </button>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Pagination;
